import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const PoolCompetition = (props) => {
  const { height, width, fill, className } = props;
  return (
    <svg
      id="pool-competition"
      width={width}
      height={height}
      stroke="none"
      className={className}
      viewBox="0 0 60 60"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9.98784 20.149L22.715 21.7852C23.1592 22.913 25.3972 28.4643 25.818 29.4577C25.818 29.4577 25.818 29.4577 25.8121 29.4577C22.1248 31.2809 18.4376 33.0982 14.7503 34.9214C16.03 34.6877 17.3273 34.5708 18.6304 34.5708C20.3367 34.5708 22.008 34.7753 23.6032 35.1785C26.823 35.9966 29.7331 37.3055 32.5438 38.5736C35.0507 39.7014 37.4232 40.7708 39.7898 41.3844C40.1229 41.472 40.4443 41.548 40.7657 41.6122C37.9608 35.868 30.4168 20.3886 28.9267 16.9818C28.2255 15.3748 27.2613 14.7788 25.894 14.6035L10.9462 12.681C8.88347 12.418 6.99601 13.873 6.72721 15.9358C6.47004 17.9986 7.92507 19.886 9.98784 20.149Z" />
      <path d="M3.97462 49.3853C4.38951 49.6834 4.86283 49.8236 5.33616 49.8236C5.44134 49.8236 5.54068 49.8177 5.64002 49.8002C6.25943 49.7184 6.84378 49.3912 7.2353 48.8477C8.74877 46.7382 11.092 45.0787 13.8209 44.167C15.387 43.647 17.0232 43.384 18.6302 43.384C24.4561 43.384 29.4524 46.8668 34.7115 48.871C37.528 49.9462 40.4673 50.741 43.6637 50.741C45.0077 50.741 46.3985 50.6008 47.8418 50.2794C51.237 49.5314 54.147 47.9186 56.2507 45.6571C56.7532 45.1137 57.2089 44.541 57.6122 43.9274C58.3251 42.8522 58.0271 41.403 56.9519 40.6901C56.5545 40.4272 56.1104 40.3045 55.6663 40.3045C54.9067 40.3045 54.1645 40.6726 53.7146 41.3504C53.5334 41.625 53.3348 41.888 53.1185 42.1452C51.6577 43.8865 49.4663 45.137 46.8368 45.7155C44.4117 46.2474 41.7354 46.0895 39.3454 45.4702C36.8327 44.8157 34.4018 43.723 31.8189 42.56C29.0725 41.3271 26.2384 40.0473 23.1647 39.2644C21.7038 38.8904 20.1728 38.7092 18.6243 38.7092C16.5148 38.7092 14.3702 39.0539 12.3308 39.7318C10.5486 40.3279 8.89486 41.1576 7.41061 42.2036C5.84454 43.3081 4.50638 44.6229 3.43117 46.1188C3.36105 46.2181 3.30261 46.3175 3.25002 46.4227C2.74164 47.4336 3.02212 48.7016 3.97462 49.3853Z" />
      <path d="M46.2933 36.1487C50.847 36.1487 54.5385 32.4572 54.5385 27.9034C54.5385 23.3497 50.847 19.6582 46.2933 19.6582C41.7396 19.6582 38.0481 23.3497 38.0481 27.9034C38.0481 32.4572 41.7396 36.1487 46.2933 36.1487Z" />
    </svg>
  );
};
/* eslint-enable max-len */

PoolCompetition.defaultProps = {
  className: null,
};

PoolCompetition.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default PoolCompetition;
